import React from 'react'
import { Link } from 'react-router-dom'

const LoginTemplate = () => {
  return (
    <Link to="/login">Login Again</Link>
  )
}

export default LoginTemplate